import AudioContexts from './audio-contexts';

const Sampler = {
  currentAudioData: undefined,

  midiToFrequency (midiNumber) {
    return 440 * Math.pow(2, (midiNumber - 69) / 12);
  },

  getPitchRatio (midiNumber) {
    return (this.midiToFrequency(midiNumber) / this.midiToFrequency(60));
  },

  getCurrentSound () {
    return this.currentAudioData;
  },

  createSample (audioData) {
    this.currentAudioData = audioData;
  },

  loadSound (soundPath) {
    this.source = this.audioCtx.context.createBufferSource();

    const request = new Request(soundPath);

    fetch(request).then(response => {
      response.arrayBuffer().then(arrayBuffer => this.loadArrayBuffer(arrayBuffer));
    });
  },

  loadArrayBuffer (arrayBuffer) {
    this.audioCtx.context.decodeAudioData(arrayBuffer)
      .then(audioData => this.createSample(audioData))
      .then(() => this.freeAudioContext);
  },

  loadAudioData (audioData) {
    this.createSample(audioData);
  },

  makePathFromSoundName (soundName) {
    if (!soundName) {
      throw new Error('No soundname passed in.');
    }

    return ['static', 'sounds', soundName].join('/');
  },

  freeAudioContext () {
    AudioContexts.freeAudioContext(this.audioCtx.guid);
  },

  init () {
    this.audioCtx = AudioContexts.getFreeAudioContext();

    const soundPath = this.makePathFromSoundName('piano.mp3');

    this.loadSound(soundPath);
  }
};

export default Sampler;



// WEBPACK FOOTER //
// ./src/components/sampler.js